export const initSearchModal = (): void => {
  const modal = document.querySelector<HTMLElement>("[data-search-modal]");
  const triggers = document.querySelectorAll<HTMLElement>(
    "[data-search-trigger]",
  );
  const closes = document.querySelectorAll<HTMLElement>("[data-search-close]");

  if (!modal) return;

  const input = modal.querySelector<HTMLInputElement>(".search-modal__input");

  const openModal = () => {
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden"; // Arka planın kaymasını engelle

    // Animasyonun bitmesini bekleyip input'a focus ol
    setTimeout(() => {
      if (input) input.focus();
    }, 100);
  };

  const closeModal = () => {
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  };

  triggers.forEach((btn) => {
    btn.addEventListener("click", openModal);
  });

  closes.forEach((btn) => {
    btn.addEventListener("click", closeModal);
  });

  // ESC tuşuna basıldığında kapat
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.getAttribute("aria-hidden") === "false") {
      closeModal();
    }
  });
};
